module.exports = __webpack_public_path__ + "img/second-day-8.5b34558d.png";